import { MantineTheme } from '@mantine/core'

export const drawerStyles = (theme: MantineTheme) => ({
  content: {
    flex: '0 0 100% !important',
    [`${theme.fn.largerThan('md')}`]: {
      flex: '0 0 40% !important',
    },
  },
})
